import { App } from 'vue';
import bus from '@/core/bus';
import { BODY_SCROLL_LOCKED } from './scroll.service';

interface HTMLElementWithFunc extends HTMLElement {
    bodyScrollLocked?: (gap: number) => void
}

const syncBodylockGap = {
    mounted(el: HTMLElement) {
        const customEl = el as HTMLElementWithFunc;
        customEl.bodyScrollLocked = (scrollbarGap: number) => {
            el.style.paddingRight = scrollbarGap + 'px';
        };
        bus.on(BODY_SCROLL_LOCKED, customEl.bodyScrollLocked);
    },
    unmounted(el: HTMLElement) {
        const customEl = el as HTMLElementWithFunc;
        if (customEl?.bodyScrollLocked) {
            bus.off(BODY_SCROLL_LOCKED, customEl.bodyScrollLocked);
            delete customEl.bodyScrollLocked;
        }
    }
};

export default function config(app: App) {
    app.directive('syncBodylockGap', syncBodylockGap);
}
